import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/main.css'
import back from './assets/img/hand.jpg'
import "./hero.css";
import logo from './assets/img/logo1.png'
import kid1 from './assets/img/kid1.jpg';
import kid2 from './assets/img/kid2.jpg';
import kid3 from './assets/img/kid3.jpg';
import kid4 from './assets/img/kid4.jpg';
import playstore from './assets/img/playstore.png';
import review from './assets/img/revbg.webp';
import art from './assets/img/art.jpeg';
import auditorium from './assets/img/auditorium.jpeg';
import canteen from './assets/img/canteen.jpeg';
import comp from './assets/img/comp.jpeg';
import library from './assets/img/library.jpeg';
import music from './assets/img/music.jpeg';
import play from './assets/img/play.jpeg';
import sci from './assets/img/sci.jpeg';
import director from './assets/img/director.jpg';
import pic1 from './assets/img/pic1.jpg';
import pic2 from './assets/img/pic2.jpg';
import pic3 from './assets/img/pic3.jpg';
import pic4 from './assets/img/pic4.jpg';
import pic5 from './assets/img/pic5.jpg';
import pdf from './assets/FEE BOOK.pdf'
import admissionformjps from './assets/img/admissionformjps.pdf'
import axios from 'axios';
import pic6 from './assets/img/pic6.jpg';
import pic7 from './assets/img/pic7.jpg';
import pic8 from './assets/img/pic8.jpg';
import recentPhoto1 from './assets/img/gallery-2026-10-13-01.jpeg';
import recentPhoto2 from './assets/img/gallery-2026-10-13-02.jpeg';
import recentPhoto3 from './assets/img/gallery-2026-10-13-03.jpeg';
import recentPhoto4 from './assets/img/gallery-2026-10-13-04.jpeg';
import recentPhoto5 from './assets/img/gallery-2026-10-13-05.jpeg';
import recentPhoto6 from './assets/img/gallery-2026-10-13-06.jpeg';
import recentPhoto7 from './assets/img/gallery-2026-10-13-07.jpeg';

const recentGalleryPhotos = [
    { image: recentPhoto1, alt: 'Student running during a school sports event', caption: 'School Sports Event' },
    { image: recentPhoto2, alt: 'School gathering under a colorful canopy', caption: 'School Gathering' },
    { image: recentPhoto3, alt: 'Students celebrating with their certificates', caption: 'Student Achievements' },
    { image: recentPhoto4, alt: 'Students and teachers celebrating an achievement', caption: 'Student Achievements' },
    { image: recentPhoto5, alt: 'Students and teachers at a school event', caption: 'School Event' },
    { image: recentPhoto6, alt: 'Students celebrating together after a school event', caption: 'School Celebration' },
    { image: recentPhoto7, alt: 'Students and teachers gathered at a school event', caption: 'School Gathering' },
];

const schoolLeaders = [
    { name: 'Mr. Parwez Alam', role: 'Vice Principal' },
    { name: 'Ms Nahid Gulfashan', role: 'Senior Coordinator' },
    { name: 'Mr. Shadab Akhter', role: 'Controller of Examinations' },
];

const Counter = ({ end, duration, isClicked }) => {
    const [count, setCount] = useState(end); // Default to the final number

    useEffect(() => {
        if (isClicked) {
            setCount(0); // Reset the counter to 0 when clicked
            let start = 0;
            const incrementTime = Math.abs(Math.floor(duration / end));

            const timer = setInterval(() => {
                start += 1;
                setCount((prevCount) => {
                    if (prevCount < end) {
                        return prevCount + 1;
                    } else {
                        clearInterval(timer);
                        return end;
                    }
                });
            }, incrementTime);

            return () => clearInterval(timer); // Cleanup interval on unmount or click end
        }
    }, [isClicked, end, duration]); // Rerun effect on click state change

    return <span>{count}</span>;
};

const testimonials = [
    {
        imgSrc: logo,
        name: 'Khadija Fatima',
        role: 'Parent',
        quote: 'My son has shown remarkable improvement in academics and extracurricular activities since joining this school. The staff is truly dedicated and caring.',
    },
    {
        imgSrc: logo,
        name: 'Ibrahim Perweez',
        role: 'Parent',
        quote: 'The school provides a well-rounded education. The classrooms are modern, and the teachers ensure every child is given personal attention.',
    },
    {
        imgSrc: logo,
        name: 'Haroon Azam',
        role: 'Parent',
        quote: 'A perfect blend of academics and co-curricular activities. The school has excellent facilities, and the principal’s leadership is inspiring.',
    },
    {
        imgSrc: logo,
        name: 'Humaira Fatima',
        role: 'Alumni Parent',
        quote: 'I’m grateful to the school for providing my child with a strong foundation. The focus on values and discipline is commendable.',
    },
    {
        imgSrc: logo,
        name: 'Sara Perween',
        role: 'Parent',
        quote: 'The faculty is approachable, and the school ensures the safety and overall development of the children. Highly recommended!',
    },
    {
        imgSrc: logo,
        name: 'Arzoo Bano',
        role: 'Parent',
        quote: 'The school’s infrastructure is excellent, and the programs are designed to bring out the best in every student. My daughter loves the environment here.',
    },
    {
        imgSrc: logo,
        name: 'Neha Gupta',
        role: 'Parent',
        quote: 'This school is a great choice for holistic development. The teachers are patient, and the management is extremely supportive.',
    },
];


const Home = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const isLaptop = window.innerWidth >= 1024;
    const [errors, setErrors] = useState({});
    const [classSelected, setClassSelected] = useState('1');
    const [comment, setComment] = useState('');
    const [heardFrom, setHeardFrom] = useState('Our Website');
    const [name, setName] = useState('');
    const [contact, setContact] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [clickedIndex, setClickedIndex] = useState(-1);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992); // Default based on screen size
    const [activeFaqIndex, setActiveFaqIndex] = useState(null);
    const [API_PARENT_LINK, setApiParent] = useState("https://jharkhandpublicenglishhighschool.com/api/AdmissionsInquiry/?school_id=5");


    const validateName = (name) => {
        return name.trim() !== '' ? '' : 'Name is required';
    };

    const validateContact = (contact) => {
        const contactRegex = /^[6-9][0-9]{9}$/;
        return contactRegex.test(contact) ? '' : 'Invalid Contact Number';
    };

    const toggleFaq = (index) => {

        setActiveFaqIndex(activeFaqIndex === index ? null : index);
    };
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
            if (window.innerWidth > 992) {
                setIsMenuOpen(false); // Close the menu when switching to desktop view
                document.body.classList.remove('mobile-nav-active');
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleOnClick = (index) => {
        setClickedIndex(index);
    };
    const stats = [
        { end: 400, duration: 5, label: 'Happy Students' },
        { end: 15, duration: 5, label: 'Clubs & Extracurricular Programs' },
        { end: 20, duration: 5, label: 'Classroom' },
        { end: 20, duration: 5, label: 'Qualified Faculty Members' },
    ];

    const handleNameChange = (e) => {
        const value = e.target.value;
        setName(value);
        setErrors((prev) => ({
            ...prev,
            name: validateName(value),
        }));
    };

    const handleContactChange = (e) => {
        const value = e.target.value;
        setContact(value);
        setErrors((prev) => ({
            ...prev,
            contact: validateContact(value),
        }));
    };
    // Reset form function
    const resetForm = () => {
        setName('');
        setContact('');
        setClassSelected('1');
        setHeardFrom('Our Website');
        setErrors({});
        setComment('');
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000); // Change slide every 3 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);
    const toggleMenu = () => {

        if (isMobile) {
            setIsMenuOpen(!isMenuOpen);
            document.body.classList.toggle('mobile-nav-active', !isMenuOpen);
        }

    };
    const validateForm = () => {
        const newErrors = {
            name: validateName(name),
            contact: validateContact(contact),
        };
        setErrors(newErrors);
        return Object.values(newErrors).every((error) => !error);
    };

    console.log(errors);


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        //alert('done')
        //toast.success('Thanks for your enquiry! We will reach out to you soon.');



        const data = {
            student_name: name,
            contact_number: contact,
            class_interested: classSelected,
            additional_comments: comment,
            how_they_came_to_know: heardFrom

        };
        console.log("data", data);


        try {

            // Axios request to your backend API
            if (!API_PARENT_LINK) {
                throw new Error("API endpoint not available");
            }
            const response = await axios.post(`${API_PARENT_LINK}`, data);
            console.log("response", response);


            if (response.status === 201) {
                setErrors({});
                toast.success('Thanks for your enquiry! We will reach out to you soon.');
                resetForm();
                // onClose();
            }
            if (response.status === 200) {
                setErrors({});
                toast.success('Your inquiry request is already with us! We will reach out to you soon.');
                resetForm();
                // onClose();
            }
        } catch (error) {
            toast.error('Failed to submit enquiry. Please try again.');
        }
    };

    return (
        <>
            <div class="topbar d-flex align-items-center" style={{ backgroundColor: '#FAE019' }}>
                <div class="container d-flex justify-content-center justify-content-md-between">
                    <div class="contact-info d-flex align-items-center">
                        {/* <i class="bi bi-envelope d-flex align-items-center mr-2"> <a href="" style={{ marginLeft: '5px' }}>contact@example.com</a></i> */}
                        <i class="bi bi-phone d-flex align-items-center ms-4"><span>+91 7979736593</span></i>
                    </div>
                    <div class="social-links d-none d-md-flex align-items-center">
                        <a href="" class="twitter"><i class="bi bi-whatsapp"></i></a>
                        <a href="" class="facebook" style={{ marginLeft: '5px' }}><i class="bi bi-facebook"></i></a>
                        <a href="" class="instagram" style={{ marginLeft: '5px' }}><i class="bi bi-instagram"></i></a>
                        <a href="" class="linkedin" style={{ marginLeft: '5px' }}><i class="bi bi-youtube"></i></a>
                    </div>
                </div>
            </div>

            <div class="branding d-flex align-items-cente" style={{
                backgroundColor: '#FAE019', position: 'sticky', top: 0, // Ensures the navbar sticks to the top when scrolling
                zIndex: 1000,
            }}>

                <div class="container position-relative d-flex align-items-center justify-content-between">
                    <a href="" class="logo d-flex align-items-center ">
                        {/* <!-- Uncomment the line below if you also wish to use an image logo --> */}
                        <img className=' rounded-2  ' src={logo} alt="" style={{ height: '100%', width: '7%', marginRight: '5px' }} />
                        <h1 class="sitename">Jharkhand Public English High School</h1>
                    </a>

                    <nav id="navmenu" className={`navmenu ${isMenuOpen ? 'open ' : ''} `} style={{
                        height: isMenuOpen ? '50%' : '',
                        //top: '80px',
                        width: isMenuOpen ? '50%' : '',
                        marginLeft: isMenuOpen ? '50%' : '',

                        backgroundColor: 'transparent',
                    }}>
                        <ul style={{ backgroundColor: isMenuOpen ? 'white' : '', width: isMenuOpen ? '50%' : '', marginLeft: isMenuOpen ? '40%' : '' }}>
                            <li><a href="#hero" class="active " onClick={() => isMobile && toggleMenu()}>Home</a></li>
                            <li><a href="#about" onClick={() => isMobile && toggleMenu()}>About</a></li>
                            {/* <li><a href="#services" onClick={() => isMobile && toggleMenu()} >Features</a></li> */}
                            <li><a href="#testimonials" onClick={() => isMobile && toggleMenu()}>Review</a></li>

                            <li><a href="#contact" onClick={() => isMobile && toggleMenu()}>Enquiry</a></li>
                            <li><a href="https://jharkhandpublicenglishhighschool.com/images/utils/app-jps-release.apk" class="btn-get-started">Download Our App</a></li>
                        </ul>
                        <i className={`mobile-nav-toggle d-xl-none bi ${isMenuOpen ? 'bi-x' : 'bi-list'}`} onClick={toggleMenu}></i>

                    </nav>

                </div>

            </div>
            {/* <!-- Hero Section --> */}
            <section id="hero" class="hero section light-background"
                style={{
                    backgroundImage: `url(${back})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: "relative",

                }}
            >

                <div class="container">
                    <div class="row gy-4">
                        <div class="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-center" data-aos="zoom-out">
                            <h1>Welcome to <span>Jharkhand Public English High School</span></h1>
                            <p>A Good Education is a Foundation for a Better Future</p>
                            <div class="d-flex">
                                <a href="#contact" class="btn-get-started">Enquiry Now</a>
                                {/* <a href="" class="glightbox btn-watch-video d-flex align-items-center"><i class="bi bi-play-circle"></i><span>Watch Video</span></a> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Bubbles Animation Section */}
                <div className="bubbles-container">
                    <div className="bubble" style={{ backgroundColor: 'blue' }}>GROW</div>
                    <div className="bubble" style={{ backgroundColor: 'pink' }}>FLY</div>
                    <div className="bubble" style={{ backgroundColor: '#FAE019' }}>LEAD</div>
                    <div className="bubble" style={{ backgroundColor: 'green' }}>SHINE</div>
                    <div className="bubble" >INSPIRE</div>
                </div>

            </section>
            {/* Marquee Section */}
            {/* Marquee Section */}
            <div
                className="marquee-container"
                style={{
                    backgroundColor: '#FAE019', // Semi-transparent dark background
                    backdropFilter: 'blur(5px)',
                    width: '100%',


                }}
            >
                <marquee behavior={isMobile ? "scroll" : "alternate"} direction="left" style={{ color: 'black', Text: 'bold', fontSize: isMobile ? '12px' : '16px' }}>
                    Hurry up ! Free Admission is going on - (Limited seats only)
                </marquee>
            </div>

            {/* Bubbles Animation Section
            <section id="bubbles" class="bubbles-section">
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            </section> */}

            {/* <!-- Featured Services Section --> */}
            <section id="featured-services" class="featured-services section">

                <div class="container">

                    <div class="row gy-4">

                        <div class="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="100">
                            <div class="service-item position-relative" style={{ backgroundImage: `url(${kid1})` }}>
                                <div class="image-text p-2" style={{}}>Personalized Learning</div>
                                <div class="icon"><i class="bi bi-person-lines-fill icon"></i></div>
                                <h4><a href="" class="stretched-link">Tailored Education</a></h4>
                                <p>Adapting lessons to meet individual learning styles and needs to maximize student potential.</p>
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="200">
                            <div class="service-item position-relative" style={{ backgroundImage: `url(${kid2})` }}>
                                <div class="image-text p-2">Digital Literacy</div>
                                <div class="icon"><i class="bbi bi-laptop icon"></i></div>
                                <h4><a href="" class="stretched-link">Tech-Savvy Students</a></h4>
                                <p>Equipping students with the skills they need to thrive in a digital world and future careers.</p>
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="300">
                            <div class="service-item position-relative" style={{ backgroundImage: `url(${kid3})` }}>
                                <div class="image-text p-2">Character Building</div>
                                <div class="icon"><i class="bi bi-heart icon"></i></div>
                                <h4><a href="" class="stretched-link">Values and Integrity</a></h4>
                                <p>Fostering responsibility, kindness, and resilience to prepare students for life's challenges.</p>
                            </div>
                        </div>

                        <div class="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="400">
                            <div class="service-item position-relative" style={{ backgroundImage: `url(${kid4})` }}>
                                <div class="image-text p-2" style={{}}>Global Exposure</div>
                                <div class="icon"><i class="bi bi-globe icon"></i></div>
                                <h4><a href="" class="stretched-link">Global Awareness</a></h4>
                                <p>Opening doors to international programs, partnerships, and cultural exchanges to broaden students' horizons.</p>
                            </div>
                        </div>

                    </div>

                </div>

            </section>

            {/* <!-- About Section --> */}
            <section id="about" class="about section light-background">


                <div class="container section-title" data-aos="fade-up">
                    <h2>About</h2>
                    <p><span>Discover</span> <span class="description-title">Our Legacy</span></p>
                </div>

                <div class="container">

                    <div class="row gy-3">

                        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                            <img src={logo} alt="" class="img-fluid" />
                        </div>

                        <div class="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
                            <div class="about-content ps-0 ps-lg-3">
                                <h3>Welcome to Jharkhand Public English High School - Shaping Young Minds Since 2008</h3>
                                <p class="fst-italic">
                                    "Education is for improving the lives of others and for leaving an impact on society."
                                    <br></br>

                                    Dear all,
                                    Jharkhand Public English High School remains committed to upholding traditional values while embracing modern learning platforms.

                                    Our website serves as a bridge, fostering collaboration between the school and parents, and ensuring effective communication. Through this platform, we aim to provide the tools and support you need to achieve your goals. Together, we can create an environment where learning thrives and opportunities flourish.
                                </p>
                                <ul>
                                    <li>
                                        <i class="bi bi-diagram-3"></i>
                                        <div>
                                            <h4>Excellence in Academics</h4>
                                            <p>With a track record of top-performing students, we foster an environment of academic rigor and intellectual growth.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <i class="bi bi-fullscreen-exit"></i>
                                        <div>
                                            <h4>Holistic Development</h4>
                                            <p> Beyond academics, we emphasize sports, arts, and extracurricular activities to ensure well-rounded growth.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <i class="bi bi-award"></i>
                                        <div>
                                            <h4>Building Future Leaders</h4>
                                            <p>
                                                Our vision is to create responsible citizens and leaders equipped with values, knowledge, and the skills to thrive in a global world.
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                                <p>
                                    Over the years, Jharkhand Public English High School has earned a reputation for excellence in education. We take pride in our dedicated faculty, modern facilities, and a student-centered approach that inspires learning and growth.
                                </p>
                            </div>

                        </div>
                    </div>

                </div>

            </section>

            {/* <!-- Skills Section --> */}
            <section id="skills" class="skills section" style={{ paddingBottom: '0px' }}>

                <div class="container" data-aos="fade-up" data-aos-delay="100">

                    <div class="row skills-content skills-animation">

                        <div class="col-lg-6">

                            <div class="progress">
                                <span class="skill"><span>Academic Excellence</span> <i class="val">95%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar"
                                        style={{ width: "95%" }}
                                        aria-valuenow="95" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>

                            <div class="progress">
                                <span class="skill"><span>Sports & Fitness</span> <i class="val">90%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar"
                                        style={{ width: "90%" }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>



                        </div>

                        <div class="col-lg-6">

                            <div class="progress">
                                <span class="skill"><span>Technological Integration</span> <i class="val">80%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar"
                                        style={{ width: "80%" }}
                                        role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill"><span>Creative Arts</span> <i class="val">75%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar"
                                        style={{ width: "75%" }} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>

                            {/* <div class="progress">
                                <span class="skill"><span>WordPress/CMS</span> <i class="val">90%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>

                            <div class="progress">
                                <span class="skill"><span>Photoshop</span> <i class="val">55%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div> */}

                        </div>

                    </div>

                </div>

            </section>

            {/* <!-- Stats Section --> */}
            <section id="stats" class="stats section">

                <div class="container" data-aos="fade-up" data-aos-delay="100">

                    <div class="row gy-4">

                        {stats.map((stat, index) => (
                            <div
                                key={index}
                                className="col-lg-3 col-md-6 d-flex flex-column align-items-center"
                                onClick={() => handleOnClick(index)} // Handle click event
                            >
                                <i className={`bi ${index === 0 ? 'bi-emoji-smile' : index === 1 ? 'bi-trophy' : index === 2 ? 'bi-headset' : 'bi-people'}`}></i>
                                <div className="stats-item">
                                    <Counter
                                        end={stat.end}
                                        duration={stat.duration}
                                        isClicked={clickedIndex === index} // Pass clicked state to the Counter
                                    />
                                    <p>{stat.label}</p>
                                </div>
                            </div>
                        ))}

                    </div>

                </div>

            </section>

            {/* <!-- Clients Section --> */}
            <section id="clients" class="clients section light-background">

                <div class="container">


                    <Swiper
                        modules={[Autoplay, Pagination]}
                        loop={true}
                        speed={600}
                        autoplay={{
                            delay: 5000,
                        }}
                        slidesPerView="auto"
                        breakpoints={{
                            320: {
                                slidesPerView: 2,
                                spaceBetween: 40,
                            },
                            480: {
                                slidesPerView: 3,
                                spaceBetween: 60,
                            },
                            640: {
                                slidesPerView: 4,
                                spaceBetween: 80,
                            },
                            992: {
                                slidesPerView: 6,
                                spaceBetween: 120,
                            },
                        }}
                        pagination={{
                            clickable: true,
                        }}

                        className="init-swiper"
                    >
                        {/* Add client slides dynamically */}
                        {[
                            { image: art, text: "Art Room" },
                            { image: auditorium, text: "Auditorium" },
                            { image: canteen, text: "Canteen" },
                            { image: comp, text: "Computer Lab" },
                            { image: library, text: "Library" },
                            { image: music, text: "Music Room" },
                            { image: play, text: "Playground" },
                            { image: sci, text: "Science Lab" },
                        ].map((client, index) => (
                            <SwiperSlide key={index}>
                                <div className="client-slide">
                                    <img
                                        src={client.image}
                                        className="img-fluid"
                                        alt={`Client ${index + 1}`}
                                    />
                                    <p className="client-text" style={{ textAlign: 'center' }}>{client.text}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>

            </section>

            {/* <!-- Services Section --> */}
            {/* <section id="services" class="services section">


                <div class="container section-title" data-aos="fade-up">
                    <h2>Services</h2>
                    <p><span>Check Our</span> <span class="description-title">Services</span></p>
                </div>

                <div class="container">

                    <div class="row gy-4">

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-activity"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Nesciunt Mete</h3>
                                </a>
                                <p>Provident nihil minus qui consequatur non omnis maiores. Eos accusantium minus dolores iure perferendis tempore et consequatur.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-broadcast"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Eosle Commodi</h3>
                                </a>
                                <p>Ut autem aut autem non a. Sint sint sit facilis nam iusto sint. Libero corrupti neque eum hic non ut nesciunt dolorem.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-easel"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Ledo Markt</h3>
                                </a>
                                <p>Ut excepturi voluptatem nisi sed. Quidem fuga consequatur. Minus ea aut. Vel qui id voluptas adipisci eos earum corrupti.</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-bounding-box-circles"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Asperiores Commodit</h3>
                                </a>
                                <p>Non et temporibus minus omnis sed dolor esse consequatur. Cupiditate sed error ea fuga sit provident adipisci neque.</p>
                                <a href="#" class="stretched-link"></a>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-calendar4-week"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Velit Doloremque</h3>
                                </a>
                                <p>Cumque et suscipit saepe. Est maiores autem enim facilis ut aut ipsam corporis aut. Sed animi at autem alias eius labore.</p>
                                <a href="#" class="stretched-link"></a>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
                            <div class="service-item position-relative">
                                <div class="icon">
                                    <i class="bi bi-chat-square-text"></i>
                                </div>
                                <a href="#" class="stretched-link">
                                    <h3>Dolori Architecto</h3>
                                </a>
                                <p>Hic molestias ea quibusdam eos. Fugiat enim doloremque aut neque non et debitis iure. Corrupti recusandae ducimus enim.</p>
                                <a href="#" class="stretched-link"></a>
                            </div>
                        </div>

                    </div>

                </div>

            </section> */}
            <div class="container section-title" data-aos="fade-up" style={{ marginTop: '20px' }}>
                <h2>Reviews</h2>
                <p><span>What Our</span> <span class="description-title">Parents Say</span></p>
            </div>
            {/* <!-- Testimonials Section --> */}
            <section id="testimonials" class="testimonials section dark-background">


                <img src={review} class="testimonials-bg" alt="" />

                <div class="container" data-aos="fade-up" style={{}}>


                    <div className="row p-2 " style={{ height: '380px' }}>
                        {[currentIndex, (currentIndex + 1) % testimonials.length].map((index) => (
                            <div key={index} className={`col-12 col-md-6 ${index !== currentIndex ? 'd-md-block d-none' : ''}`}>
                                <div className="testimonial-item  p-2  rounded shadow" style={{ height: '350px' }}>
                                    {/* Uncomment if you want to display user images */}
                                    <div
                                        className="testimonial-initial"
                                        style={{
                                            width: '80px',
                                            height: '80px',
                                            borderRadius: '50%',
                                            backgroundColor: '#DC2B1C', // Replace with desired background color
                                            color: '#fff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '32px',
                                            //fontWeight: 'bold',
                                            margin: '0 auto 20px', // Center and add bottom margin
                                        }}
                                    >
                                        {testimonials[index].name.split(' ').map((namePart) => namePart.charAt(0).toUpperCase()).join('')}
                                    </div>
                                    <h3 style={{ color: 'black' }}>{testimonials[index].name}</h3>
                                    {/* <h4>{testimonials[index].role}</h4> */}
                                    <div className="stars mb-2" >
                                        {[...Array(5)].map((_, i) => (
                                            <i key={i} className="bi bi-star-fill"></i>
                                        ))}
                                    </div>
                                    <p style={{ color: 'black' }}>
                                        <i className="bi bi-quote quote-icon-left"></i>
                                        {testimonials[index].quote}
                                        <i className="bi bi-quote quote-icon-right"></i>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>


                </div>

            </section>



            {/* <!-- Team Section --> */}
            <section id="team" class="team section light-background">


                <div class="container section-title" data-aos="fade-up">
                    <h2>Princple</h2>
                    <p><span>Our </span> <span class="description-title">Director</span></p>
                </div>

                <div class="container p-2">

                    <div class="row gy-4 p-2">



                        <div class="row align-items-center">
                            {/* <!-- Left Side: Director Image --> */}
                            <div class="col-lg-4 col-md-12  d-flex justify-content-center" data-aos="fade-right" data-aos-delay="100">
                                <div class="director-img  "  >
                                    <img src={director} class="img-fluid rounded-sm" alt="School Director" style={{ height: '350px', paddingLeft: !isMobile ? '30px' : '', width: '280px' }} />
                                </div>

                            </div>

                            {/* <!-- Right Side: Director Description --> */}
                            <div class="col-lg-8 col-md-12" data-aos="fade-left" data-aos-delay="200" style={{}}>
                                <div class="director-info p-4 rounded-4 shadow-sm" style={{ paddingLeft: isMobile ? '' : '120px', backgroundColor: 'white' }}>
                                    <h2>Meet Our Director</h2>
                                    <h4>Mr. Khalid</h4>
                                    <p>
                                        Md. Khalid Siddiqui is the esteemed Director of Jharkhand Public English High School, where he leads the institution with a deep passion for academic excellence and student development.
                                        <br></br>

                                        With over 30 years of experience in education, Mr. Khalid Siddiqui has helped countless students shape their careers. He is deeply committed to the growth and well-being of every student. As Director, he continues to lead with integrity, inspiring both staff and students to reach their fullest potential.
                                    </p>
                                    {/* <div class="social">
                                        <a href="#"><i class="bi bi-twitter " style={{ marginLeft: '5px' }}></i></a>
                                        <a href="#"><i class="bi bi-facebook " style={{ marginLeft: '5px' }}></i></a>
                                        <a href="#"><i class="bi bi-instagram" style={{ marginLeft: '5px' }}></i></a>
                                        <a href="#"><i class="bi bi-linkedin" style={{ marginLeft: '5px' }}></i></a>
                                    </div> */}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row gy-4 mt-4">
                        {schoolLeaders.map((leader) => (
                            <div class="col-lg-4 col-md-6" key={leader.name}>
                                <div class="team-member h-100">
                                    <div
                                        class="member-img staff-photo-placeholder"
                                        role="img"
                                        aria-label={`${leader.name} photograph placeholder`}
                                    />
                                    <div class="member-info">
                                        <h4>{leader.name}</h4>
                                        <span>{leader.role}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>

            </section>

            {/* <!-- Portfolio Section --> */}
            <section id="portfolio" class="portfolio section">


                <div class="container section-title" data-aos="fade-up">
                    <h2>Gallery</h2>
                    <p><span>Check Our&nbsp;</span> <span class="description-title">Gallery</span></p>
                </div>

                <div class="container">

                    <div class="isotope-layout" data-default-filter="*" data-layout="masonry" data-sort="original-order">

                        {/* <ul class="portfolio-filters isotope-filters" data-aos="fade-up" data-aos-delay="100">
                            <li data-filter="*" class="filter-active">All</li>
                            <li data-filter=".filter-app">App</li>
                            <li data-filter=".filter-product">Card</li>
                            <li data-filter=".filter-branding">Web</li>
                        </ul> */}

                        <div class="row gy-4 isotope-container" data-aos="fade-up" data-aos-delay="200">

                            {recentGalleryPhotos.map((photo) => (
                                <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-app" key={photo.image}>
                                    <img src={photo.image} class="img-fluid" alt={photo.alt} />
                                    <div class="portfolio-info">
                                        <p>{photo.caption}</p>
                                    </div>
                                </div>
                            ))}

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-app">
                                <img src={kid4} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Jharkhand Public English High School</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={kid4} title="Jharkhand Public English High School" data-gallery="portfolio-gallery-app" class="glightbox preview-link "><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-product">
                                <img src={kid3} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Product 1</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={kid3} title="Product 1" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-branding">
                                <img src={kid2} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Branding 1</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={kid2} title="Branding 1" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-app">
                                <img src={kid1} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>App 2</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={kid1} title="App 2" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-product">
                                <img src={pic1} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Product 2</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={pic1} title="Product 2" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-branding">
                                <img src={pic2} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Branding 2</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={pic2} title="Branding 2" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-app">
                                <img src={pic3} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>App 3</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={pic3} title="App 3" data-gallery="portfolio-gallery-app" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-product">
                                <img src={pic4} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Product 3</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={pic4} title="Product 3" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-branding">
                                <img src={pic5} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Branding 3</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={pic5} title="Branding 2" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-app">
                                <img src={pic6} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Jharkhand Public English High School</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={pic6} title="Jharkhand Public English High School" data-gallery="portfolio-gallery-app" class="glightbox preview-link "><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-product">
                                <img src={pic7} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Product 1</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={pic7} title="Product 1" data-gallery="portfolio-gallery-product" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                            <div class="col-lg-3 col-md-4 portfolio-item isotope-item filter-branding">
                                <img src={pic8} class="img-fluid" alt="" />
                                <div class="portfolio-info">
                                    {/* <h4>Branding 1</h4> */}
                                    <p>Jharkhand Public English High School</p>
                                    {/* <a href={pic8} title="Branding 1" data-gallery="portfolio-gallery-branding" class="glightbox preview-link"><i class="bi bi-zoom-in"></i></a> */}
                                    {/* <a href="portfolio-details.html" title="More Details" class="details-link"><i class="bi bi-link-45deg"></i></a> */}
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* <!-- Pricing Section --> */}
            {/* <section id="pricing" class="pricing section">


                <div class="container section-title" data-aos="fade-up">
                    <h2>Pricing</h2>
                    <p><span>Check our</span> <span class="description-title">Pricing</span></p>
                </div>

                <div class="container">

                    <div class="row gy-3">

                        <div class="col-xl-3 col-lg-6" data-aos="fade-up" data-aos-delay="100">
                            <div class="pricing-item">
                                <h3>Free</h3>
                                <h4><sup>$</sup>0<span> / month</span></h4>
                                <ul>
                                    <li>Aida dere</li>
                                    <li>Nec feugiat nisl</li>
                                    <li>Nulla at volutpat dola</li>
                                    <li class="na">Pharetra massa</li>
                                    <li class="na">Massa ultricies mi</li>
                                </ul>
                                <div class="btn-wrap">
                                    <a href="#" class="btn-buy">Buy Now</a>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-3 col-lg-6" data-aos="fade-up" data-aos-delay="200">
                            <div class="pricing-item featured">
                                <h3>Business</h3>
                                <h4><sup>$</sup>19<span> / month</span></h4>
                                <ul>
                                    <li>Aida dere</li>
                                    <li>Nec feugiat nisl</li>
                                    <li>Nulla at volutpat dola</li>
                                    <li>Pharetra massa</li>
                                    <li class="na">Massa ultricies mi</li>
                                </ul>
                                <div class="btn-wrap">
                                    <a href="#" class="btn-buy">Buy Now</a>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-3 col-lg-6" data-aos="fade-up" data-aos-delay="400">
                            <div class="pricing-item">
                                <h3>Developer</h3>
                                <h4><sup>$</sup>29<span> / month</span></h4>
                                <ul>
                                    <li>Aida dere</li>
                                    <li>Nec feugiat nisl</li>
                                    <li>Nulla at volutpat dola</li>
                                    <li>Pharetra massa</li>
                                    <li>Massa ultricies mi</li>
                                </ul>
                                <div class="btn-wrap">
                                    <a href="#" class="btn-buy">Buy Now</a>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-3 col-lg-6" data-aos="fade-up" data-aos-delay="400">
                            <div class="pricing-item">
                                <span class="advanced">Advanced</span>
                                <h3>Ultimate</h3>
                                <h4><sup>$</sup>49<span> / month</span></h4>
                                <ul>
                                    <li>Aida dere</li>
                                    <li>Nec feugiat nisl</li>
                                    <li>Nulla at volutpat dola</li>
                                    <li>Pharetra massa</li>
                                    <li>Massa ultricies mi</li>
                                </ul>
                                <div class="btn-wrap">
                                    <a href="#" class="btn-buy">Buy Now</a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </section> */}






            <section id="faq" class="faq section light-background" >


                <div class="container section-title" data-aos="fade-up">
                    <h2>F.A.Q</h2>
                    <p><span>Frequently Asked</span> <span class="description-title">Questions</span></p>
                </div>

                <div class="container">

                    <div class="row justify-content-center">

                        <div class="col-lg-10" data-aos="fade-up" data-aos-delay="100">

                            <div class="faq-container">

                                <div class={`faq-item ${activeFaqIndex === 0 ? 'faq-active' : ''}`} onClick={() => toggleFaq(0)}>
                                    {/* <i className="faq-icon bi bi-question-circle"></i> */}
                                    <h3>How can I apply for admission?</h3>
                                    <div class="faq-content">
                                        <p>                To apply for admission, you need to fill out the application form available on our website or at the school office. Ensure you attach all necessary documents, such as the student's birth certificate, previous school records, and recent photographs. Once submitted, our team will guide you through the next steps, which may include an assessment or interview depending on the grade level.
                                            <br></br>
                                            <a
                                                href={admissionformjps}
                                                download

                                                style={{
                                                    marginTop: '10px',
                                                    display: 'inline-block',
                                                    backgroundColor: 'white',
                                                    color: '#DC2B1C',
                                                    padding: '10px 20px',
                                                    border: '2px solid #DC2B1C',
                                                    borderRadius: '5px',
                                                    textDecoration: 'none',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Download Admission Form (PDF)
                                            </a>
                                        </p>
                                    </div>
                                    <i class="faq-toggle bi bi-chevron-right"></i>
                                </div>
                                {/* <i className="faq-toggle bi bi-chevron-right"></i> */}

                                <div class={`faq-item ${activeFaqIndex === 1 ? 'faq-active' : ''}`} onClick={() => toggleFaq(1)}>
                                    <h3>What facilities does the school offer?</h3>
                                    <div class="faq-content">
                                        <p>                We provide a variety of amenities to support students' academic and extracurricular growth. These include modern classrooms, a fully equipped library, computer and science laboratories, sports facilities, and activity rooms for music, arts, and crafts. Additionally, our campus features a cafeteria offering healthy meals and a medical room for first aid and health checkups.
                                        </p>
                                    </div>
                                    <i class="faq-toggle bi bi-chevron-right"></i>
                                </div>

                                <div class={`faq-item ${activeFaqIndex === 2 ? 'faq-active' : ''}`} onClick={() => toggleFaq(2)}>
                                    <h3>What are the school fees?</h3>
                                    <div class="faq-content">
                                        <p>                The school fees depend on the grade level and include tuition, activity charges, and examination fees. Additional costs may apply for transport, uniforms, or extracurricular activities. Detailed fee information is available upon request from our admissions office or can be downloaded from our website.
                                            <br></br>
                                            <a
                                                href={pdf}
                                                download

                                                style={{
                                                    marginTop: '10px',
                                                    display: 'inline-block',
                                                    backgroundColor: 'white',
                                                    color: '#DC2B1C',
                                                    padding: '10px 20px',
                                                    border: '2px solid #DC2B1C',
                                                    borderRadius: '5px',
                                                    textDecoration: 'none',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Download Fee Structure (PDF)
                                            </a>
                                        </p>

                                    </div>
                                    <i class="faq-toggle bi bi-chevron-right"></i>
                                </div>

                                <div class={`faq-item ${activeFaqIndex === 3 ? 'faq-active' : ''}`} onClick={() => toggleFaq(3)}>
                                    <h3>What security measures does the school have?</h3>
                                    <div class="faq-content">
                                        <p>                Our campus is designed with safety as a top priority. We have a comprehensive security system with 24/7 CCTV surveillance, secure entry points, and ID verification for all visitors. Regular safety drills are conducted to ensure preparedness for emergencies. Additionally, trained security personnel and first-aid staff are always on-site to address any concerns promptly.
                                        </p>
                                    </div>
                                    <i class="faq-toggle bi bi-chevron-right"></i>
                                </div>



                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* <!-- Contact Section --> */}
            <section id="contact" class="contact section">


                <div class="container section-title" data-aos="fade-up">
                    <h2>Contact</h2>
                    <p><span>Need Help?</span> <span class="description-title">Contact Us</span></p>
                </div>

                <div class="container" data-aos="fade-up" data-aos-delay="100">

                    <div class="row gy-4">

                        <div class="col-lg-5">

                            <div class="info-wrap">
                                <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
                                    <i class="bi bi-geo-alt flex-shrink-0"></i>
                                    <div>
                                        <h3>Address</h3>
                                        <h6 style={{ color: '#DC2B1C' }}>Branch 1</h6>
                                        <p>
                                            135 , old purulia road , zakir nagar East mango Jamshedpur
                                            832110

                                        </p>
                                        <h6 style={{ color: '#DC2B1C' }}>Branch 2</h6>
                                        <p>


                                            Near durga mandir , Mahto Line, Kapali , Saraikela Kharsawan</p>
                                    </div>
                                </div>

                                <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
                                    <i class="bi bi-telephone flex-shrink-0"></i>
                                    <div>
                                        <h3>Call Us</h3>
                                        <p>+91 7979736593</p>
                                    </div>
                                </div>

                                <div class="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                                    <i class="bi bi-envelope flex-shrink-0"></i>
                                    <div>
                                        <h3>Email Us</h3>
                                        <p>jpehszknjsr123@gmail.com</p>
                                    </div>
                                </div>

                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29415.574632972995!2d86.1530237!3d22.8414566!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f5e3bb615c37c9%3A0xee680f7c577d2d18!2sJharkhand%20Public%20English%20High%20School!5e0!3m2!1sen!2sin!4v1736355321705!5m2!1sen!2sin" width="100%" height="270" style={{ border: '0' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>

                        <div class="col-lg-7">
                            <form class="php-email-form" data-aos="fade-up" data-aos-delay="200">
                                <div class="row gy-4">

                                    <div class="col-md-6">
                                        <input type="text" name="name" className={`form-control  ${errors.name ? 'is-invalid' : ''}`} placeholder="Your Name" required="" value={name}
                                            onChange={handleNameChange} />
                                        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                    </div>

                                    <div class="col-md-6">
                                        <input type="text" className={`form-control  ${errors.contact ? 'is-invalid' : ''}`} name="contact" placeholder="Contact" required="" value={contact}
                                            onChange={handleContactChange} maxLength="10" />
                                        {errors.contact && <div className="invalid-feedback">{errors.contact}</div>}
                                    </div>

                                    <div class="col-md-12">
                                        <label className="form-label small" style={{ color: '#B9C8D6' }}>Class</label>
                                        {/* <input type="text" class="form-control" name="Class" placeholder="Class" required="" /> */}
                                        <select
                                            className="form-select  "
                                            value={classSelected}
                                            onChange={(e) => setClassSelected(e.target.value)}
                                        // style={{
                                        //   border: '1px solid gray',
                                        //   transition: 'box-shadow 0.2s, border-color 0.2s',
                                        // }}
                                        >
                                            <option value="Nursery">Nursery</option>
                                            <option value="LKG">LKG</option>
                                            <option value="UKG">UKG</option>
                                            {[...Array(10)].map((_, i) => (
                                                <option key={i + 1} value={i + 1}>
                                                    {i + 1}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div class="col-md-12">
                                        <label className="form-label small" style={{ color: '#B9C8D6' }}>How did you hear about us?</label>
                                        <select
                                            className="form-select "
                                            value={heardFrom}
                                            onChange={(e) => setHeardFrom(e.target.value)}
                                            style={{
                                                //border: '1px solid #FFCD40',
                                                // transition: 'box-shadow 0.2s, border-color 0.2s',
                                            }}
                                        >
                                            <option value="Our Website">Our Website</option>
                                            <option value="Friends and Family">Friends and Family</option>
                                            <option value="Staff and Teachers">Staff and Teachers</option>
                                            <option value="Banner and Hoarding">Banner and Hoarding</option>
                                            <option value="News Channel">News Channel</option>
                                            <option value="Facebook">Facebook</option>
                                            <option value="YouTube">YouTube</option>
                                            <option value="Instagram">Instagram</option>
                                            <option value="Others">Others</option>
                                        </select>
                                    </div>

                                    <div class="col-md-12 text-center">
                                        <textarea class="form-control" name="message" rows="6" placeholder="Message" required="" value={comment}
                                            onChange={(e) => setComment(e.target.value)}></textarea>
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <div class="loading">Loading</div>
                                        <div class="error-message"></div>
                                        <div class="sent-message">Your message has been sent. Thank you!</div>

                                        <button type="submit" onClick={handleSubmit} >Send Message</button>
                                    </div>

                                </div>
                            </form>
                        </div>

                    </div>

                </div>
                <ToastContainer />

            </section>
            <footer id="footer" class="footer" style={{ backgroundColor: '#f7e13b' }}>

                {/* <div class="footer-newsletter">
                    <div class="container">
                        <div class="row justify-content-center text-center">
                            <div class="col-lg-6">
                                <h4>Join Our Newsletter</h4>
                                <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
                                <form action="forms/newsletter.php" method="post" class="php-email-form">
                                    <div class="newsletter-form"><input type="email" name="email" /><input type="submit" value="Subscribe" /></div>
                                    <div class="loading">Loading</div>
                                    <div class="error-message"></div>
                                    <div class="sent-message">Your subscription request has been sent. Thank you!</div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div> */}

                <div class="container footer-top" >
                    <div class="row gy-4">
                        <div class="col-lg-6 col-md-8 footer-about">
                            <a href="index.html" class="d-flex align-items-center">
                                <span class="sitename">JHARKHAND PUBLIC ENGLISH HIGH SCHOOL</span>
                            </a>
                            <div class="footer-contact pt-3">
                                <h6 style={{ color: '#DC2B1C' }}>Branch 1</h6>
                                <p>
                                    135 , old purulia road , zakir nagar East mango Jamshedpur
                                    832110

                                </p>
                                <h6 style={{ color: '#DC2B1C' }}>Branch 2</h6>
                                <p>


                                    Near durga mandir , Mahto Line, Kapali , Saraikela Kharsawan</p>
                                <p class="mt-3"><strong>Phone:</strong> <span>+91 7979736593</span></p>
                                <p><strong>Email:</strong> <span>jpehszknjsr123@gmail.com</span></p>
                            </div>
                        </div>

                        {/* <div class="col-lg-2 col-md-3 footer-links">
                            <h4>Useful Links</h4>
                            <ul>
                                <li><i class="bi bi-chevron-right"></i> <a href="#">Home</a></li>
                                <li><i class="bi bi-chevron-right"></i> <a href="#">About us</a></li>
                                <li><i class="bi bi-chevron-right"></i> <a href="#">Services</a></li>
                                <li><i class="bi bi-chevron-right"></i> <a href="#">Terms of service</a></li>
                            </ul>
                        </div> */}

                        <div class="col-lg-2 col-md-3 footer-links">
                            <h4>Our App</h4>
                            {/* <ul>
                                <li><i class="bi bi-chevron-right"></i> <a href="#">Web Design</a></li>
                                <li><i class="bi bi-chevron-right"></i> <a href="#">Web Development</a></li>
                                <li><i class="bi bi-chevron-right"></i> <a href="#">Product Management</a></li>
                                <li><i class="bi bi-chevron-right"></i> <a href="#">Marketing</a></li>
                            </ul> */}
                            <img
                                src={playstore}  // Replace this with your image URL
                                alt="Our App"
                                style={{
                                    width: '100%',  // Adjust the size of the image as needed
                                    cursor: 'pointer',  // Makes the image look clickable
                                    borderRadius: '5px',
                                    left: '0px'
                                }}
                            />
                        </div>

                        <div class="col-lg-4 col-md-12">
                            <h4>Follow Us</h4>
                            {/* <p>Cras fermentum odio eu feugiat lide par naso tierra videa magna derita valies</p> */}
                            <div class="social-links d-flex">
                                <a href="https://wa.me/917979736593"><i class="bi bi-whatsapp"></i></a>
                                <a href=""><i class="bi bi-facebook"></i></a>
                                <a href=""><i class="bi bi-instagram"></i></a>
                                <a href=""><i class="bi bi-youtube"></i></a>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="container copyright text-center mt-4">
                    <p>© <span>Copyright</span> <strong class="px-1 sitename">ThevectorX</strong> <span>All Rights Reserved</span></p>
                    <div class="credits">
                        {/* <!-- All the links in the footer should remain intact. -->
                            <!-- You can delete the links only if you've purchased the pro version. -->
                            <!-- Licensing information: https://ThevectorX.com/license/ -->
                            <!-- Purchase the pro version with working PHP/AJAX contact form: [buy-url] --> */}
                        Designed by <a href="https://ThevectorX.com/">ThevectorX</a>
                    </div>
                </div>

            </footer>

            {/* <!-- Scroll Top --> */}
            <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

            {/* <!-- Preloader --> */}
            {/* <div id="preloader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div> */}

            {/* <!-- Vendor JS Files --> */}
            <script src="assets/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
            <script src="assets/vendor/php-email-form/validate.js"></script>
            <script src="assets/vendor/aos/aos.js"></script>
            <script src="assets/vendor/glightbox/js/glightbox.min.js"></script>
            <script src="assets/vendor/waypoints/noframework.waypoints.js"></script>
            <script src="assets/vendor/purecounter/purecounter_vanilla.js"></script>
            <script src="assets/vendor/swiper/swiper-bundle.min.js"></script>
            <script src="assets/vendor/imagesloaded/imagesloaded.pkgd.min.js"></script>
            <script src="assets/vendor/isotope-layout/isotope.pkgd.min.js"></script>

            {/* <!-- Main JS File --> */}
            <script src="assets/js/main.js"></script>

        </>
    )
}

export default Home